import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { EguardValidationService } from '../../../core/components/validation/validation.service';
import { EguardConfirmatialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';
import { MatStepper } from '@angular/material';
import { CaseService } from '../../shared/services/case.service';
import { CognitoUtil } from '../../shared/services/cognito.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { CommentService } from '../../shared/services/comment.service';
import { UserService } from '../../shared/services/user.service';
import { StripePaymentService } from '../../shared/services/stripePayment.service';
import { FormsService } from '../../shared/services/forms.service';
import { LocalUserService } from '../../shared/services/localUser';
import { environment } from '../../../../environments/environment';
import { NotifyPopupComponent } from '../common/notify-popup/notify-popup.component';


/*
  this is for dee DELETE AFTER
  -chris
 */

@Component({
    selector: 'dee',
    templateUrl: './dee.component.html',
    styleUrls : ['dee.component.scss'],
    providers: [
      CaseService,
      CommentService,
      UserService,
      StripePaymentService,
      FormsService
    ]
})
export class DeeComponent implements OnInit {

  fsmId = null;
  caseId = undefined;
  role = null;

  /*
  null = NEW FORM
  review = COURT TIME
  resubmit = RESUBMIT
   */
  stepStatus = null;
  disableEdit = false;

  loading = true;

  jsonSchema = [];
  dataStorage = {};

  currentPage = 0;

  messageStatus;

  formFee;

  formActionLoading = false;
  formActionLoadingDeny = false;
  formActionLoadingApprove = false;

  transactionId = null;

  org;
  userId;

  caseData = null;
  formId = null;

  dialogRef: any;

  constructor(
      public dialog: MatDialog,
      public snackBar: MatSnackBar,
      private caseService: CaseService,
      private cognito: CognitoUtil,
      private route: ActivatedRoute,
      private router: Router,
      private stripeService: StripePaymentService,
      private localUser: LocalUserService
  )
  {



  }

  upload(event){
    this.loading = true;
    this.jsonSchema = [];
    this.dataStorage = {};

    // this makes sure they did not just back out of the file selector.
    if (event.target.files.length === 0) {
      return 0;
    }

    let file = event.target.files[0];

    let reader = new FileReader();
    reader.onload = () => {
      // this 'text' is the content of the file
      let text = reader.result;
      this.jsonSchema = JSON.parse(text);
      this.addDataToScehma();
    };
    reader.readAsText(file);

  }

  ngOnInit() {
    // this removes the submit button.
    // do not remove
    $('.content').on('DOMNodeInserted', function(){
      $('.mat-raised-button.mat-primary').remove();
    });
  }

  // the purpose of this is to setup default blank data for the form to bind to.
  addDataToScehma(){
    for (let i = 0; i < this.jsonSchema.length; i++) {

      let key = this.jsonSchema[i].layout[0].key;

      let dataObject = {};
      dataObject[key] = {};
      this.jsonSchema[i]['data'] = dataObject;
      this.dataStorage[key] = { };
    }
    this.loading = false;
  }

  // the point of this is to change the form when the page changes.
  goBack(stepper: MatStepper){
    this.saveFormData();

    // this is so you can not fall below 0
    if (this.currentPage !== 0){
      this.currentPage--;
      stepper.previous();
    }
    this.messageStatus = null;
  }

  // the point of this is to change the form when the page changes.
  goForward(stepper: MatStepper){
    this.saveFormData();
    // this.jsonSchema[this.getCurrentKey()].data = this.dataStorage[this.getCurrentKey()];
    // this can not go above the max length
    if (this.currentPage !== this.jsonSchema.length){
      this.currentPage++;
      stepper.next();
    }
    this.messageStatus = null;
  }

  saveFormData(){
    this.jsonSchema[this.currentPage].data[this.getCurrentKey()] = this.dataStorage[this.getCurrentKey()];
  }

  getCurrentKey(){
    return this.jsonSchema[this.currentPage].layout[0].key;
  }

  // this saves the form anytime the user changes something
  // on load this gives an error because we are in dev
  // https://github.com/angular/angular/issues/6005
  // it seems it is ignorable
  formChange(event){
    this.updateStorage(event);
  }

  updateStorage(event){
    // the purpose of the ternary is to avoid undefined getting into the json schema and dataobject
    // if that happens it can not bind correctly to the forms.
    this.dataStorage[this.jsonSchema[this.currentPage].layout[0].key] =
      event[this.jsonSchema[this.currentPage].layout[0].key] === undefined ? { } : event[this.jsonSchema[this.currentPage].layout[0].key];
  }

  stepperSelectionChange(event) {
    this.saveFormData();
    this.currentPage = event.selectedIndex;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/dee/dee.component.ts